export const TRIGGER_CRON = 'ENGAGEMENT_CASE_REPORT/TRIGGER_CRON';
export const SET_TRIGGER_LOADING = 'ENGAGEMENT_CASE_REPORT/SET_TRIGGER_LOADING';
export const SET_CURRENT_MODAL = 'ENGAGEMENT_CASE_REPORT/SET_CURRENT_MODAL';
export const FETCH_CRON_STATUS = 'ENGAGEMENT_CASE_REPORT/FETCH_CRON_STATUS';
export const SET_CRON_STATUS = 'ENGAGEMENT_CASE_REPORT/SET_CRON_STATUS';
export const START_POLLING = 'ENGAGEMENT_CASE_REPORT/START_POLLING';
export const STOP_POLLING = 'ENGAGEMENT_CASE_REPORT/STOP_POLLING';
export const RESET_CRON = 'ENGAGEMENT_CASE_REPORT/RESET_CRON';
export const SET_RESET_LOADING = 'ENGAGEMENT_CASE_REPORT/SET_RESET_LOADING';

export const triggerCronAction = data => ({ type: TRIGGER_CRON, data });

export const setTriggerLoadingAction = data => ({
  type: SET_TRIGGER_LOADING,
  data,
});

export const setCurrentModalAction = data => ({
  type: SET_CURRENT_MODAL,
  data,
});

export const fetchCronStatusAction = () => ({ type: FETCH_CRON_STATUS });

export const setCronStatusAction = data => ({ type: SET_CRON_STATUS, data });

export const startPollingAction = () => ({ type: START_POLLING });

export const stopPollingAction = () => ({ type: STOP_POLLING });

export const FETCH_CRON_RUNS = 'ENGAGEMENT_CASE_REPORT/FETCH_CRON_RUNS';
export const SET_CRON_RUNS = 'ENGAGEMENT_CASE_REPORT/SET_CRON_RUNS';

export const fetchCronRunsAction = data => ({
  type: FETCH_CRON_RUNS,
  data,
});

export const setCronRunsAction = data => ({
  type: SET_CRON_RUNS,
  data,
});
export const resetCronAction = () => ({ type: RESET_CRON });

export const setResetLoadingAction = data => ({
  type: SET_RESET_LOADING,
  data,
});

export const CLEAR_AGGREGATION_CACHE =
  'ENGAGEMENT_CASE_REPORT/CLEAR_AGGREGATION_CACHE';
export const SET_CLEAR_CACHE_LOADING =
  'ENGAGEMENT_CASE_REPORT/SET_CLEAR_CACHE_LOADING';

export const clearAggregationCacheAction = data => ({
  type: CLEAR_AGGREGATION_CACHE,
  data,
});

export const setClearCacheLoadingAction = data => ({
  type: SET_CLEAR_CACHE_LOADING,
  data,
});
